module.exports = __webpack_public_path__ + "img/circle-t.54c46049.svg";